import useRequest from "use-request";
import { AppSettings } from "./get-app-settings";
import loadCompanySettings from "./load-company-settings";

export default function useAppSettings(
  given?: AppSettings
): [appSettings: AppSettings | undefined, pending: boolean] {
  const { value, pending } = useRequest<AppSettings | undefined>(async () => {
    if (given) return given;

    const hostname = window.location.hostname;

    const customDomain =
      hostname !== "localhost" &&
      hostname !== "help.getatlas.io" &&
      hostname !== "help.atlas.so"
        ? hostname
        : undefined;

    const companySlug = !customDomain
      ? window.location.pathname.split("/")[1]
      : undefined;

    const resolvedUrl = customDomain
      ? window.location.pathname.slice(1) || ""
      : companySlug
      ? window.location.pathname.slice(1 + companySlug.length + 1)
      : "";

    const options: { domain: string } | { slug: string } | null = customDomain
      ? { domain: customDomain }
      : companySlug
      ? { slug: companySlug }
      : null;

    if (!options) return undefined;

    try {
      const companySettings = await loadCompanySettings(options);
      if (!companySettings) return undefined;
      return {
        ...companySettings,
        canonicalPageUrl: resolvedUrl,
        // TODO: Ensure they have the same format
        isServedFromCustomDomain:
          (companySettings.customDomain &&
            new URL(companySettings.customDomain).host === customDomain) ||
          false,
      };
    } catch (e) {
      return undefined;
    }
  }, [given]);
  return [value, pending];
}
